import { createFileRoute } from "@tanstack/react-router"
import { MarketingGateLayout } from "@/widgets/marketing-gate"

export const Route = createFileRoute("/(marketing)/marketing")({
	component: MarketingGateLayout,
})
